import React from 'react';
import {t} from '@lingui/core/macro';

import OAuthButton from 'shared/ui/Button/OAuthButton/OAuthButton';
import YandexButtonIcon from 'shared/ui/icons/YandexButtonIcon';
import VKButtonIcon from 'shared/ui/icons/VKButtonIcon';
import {WebOnly} from 'shared/ui/PlatformWrapper/PlatformWrapper';

import styles from './OAuthButtons.module.scss';

interface IOAuthButtonsProps {
    onSelect: (_provider: 'yandex' | 'vk') => void;
    isLoading: boolean;
}

const OAuthButtons: React.FC<IOAuthButtonsProps> = ({onSelect, isLoading}) => (
    <WebOnly>
        <OAuthButton
            icon={<YandexButtonIcon/>}
            label="Войти через Яндекс"
            onClick={() => onSelect('yandex')}
            isLoading={isLoading}
        />
        <div className={styles.next}>
            <OAuthButton
                icon={<VKButtonIcon/>}
                label={t`Войти через VK`}
                onClick={() => onSelect('vk')}
                isLoading={isLoading}
            />
        </div>
    </WebOnly>
);

export default OAuthButtons;
